import axios from 'axios';
import { store } from '~/App';
import snackbar from '~/store/ducks/snackbar';
import { getToken, isAuthenticated, logout } from './auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

api.interceptors.request.use(async config => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

const showError = (status, error) => {
  const message = {
    color: 'danger',
    icon: 'alert-circle',
    message: `Error ${status}: ${error}`
  };

  store.dispatch(snackbar.showSnackbar(message));

  setTimeout(() => {
    store.dispatch(snackbar.hideSnackbar());
  }, 10000);
};

api.interceptors.response.use(
  res => res,
  error => {
    const { status, data } = error.response;

    if (status !== 404) {
      if (status === 401) {
        if (isAuthenticated()) {
          const url = `${process.env.REACT_APP_API_URL}/v1/me`;
          const token = getToken();

          axios
            .get(url, {
              headers: {
                Authorization: `Bearer ${token}`
              }
            })
            .then(() => {
              showError(
                401,
                'Você não possui permissão para essa funcionalidade!'
              );
            })
            .catch(({ response }) => {
              if (response.status === 401) {
                logout();
                window.location.href = '/';
              }
            });
        }
      } else if (status === 500) {
        showError(status, 'Erro interno do servidor!');
      } else {
        showError(status, data.error);
      }
    }

    return error;
  }
);

export default api;
